import { Appear } from "@features/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Callout Left",
}

export default defineBlock("content/callout-left", (props) => {
  return (
    <Appear
      className={cn("callout-left w-full h-full p-5 flex flex-col gap-6 items-start justify-between self-stretch")}
    >
      <div className="w-full flex flex-col gap-3">
        <EditableText store="callout-left-label" className="type-label-s" placeholder="Enter label here" />
        <EditableText store="callout-left-heading" className="type-body-l" placeholder="Enter heading here" />
      </div>
      <InnerBlocks
        allowedBlocks={["#inline"]}
        defaultBlocks={[
          ["core/paragraph", { className: "is-style-body-small", placeholder: "Enter text here" }],
          ["core/button", { className: "is-style-button-invert", placeholder: "Enter button text here" }],
        ]}
        className="w-full flex flex-col gap-6 [&_p]:!my-0"
      />
    </Appear>
  )
})
